import ProfileController from '../controllers/profileController';
import AccountModel from './accountModel';
import StoreModel from './storeModel';
// import PasswordModel from './passwordModel';
import AuthModel from './authModel';
import Service from '../services/services';
import { CODE39 } from 'io-barcode';
import { configureStore } from '../store';
import { formatEmployeeId } from '@account/js/helpers/helpers';

/**
 * Model used for /profile
 */
class ProfileModel extends AccountModel {
    // Pass in additional models needed in class methods
    constructor(StoreModel) {
        super();
        this.profile = {
            sterlingId: '',
            name: {
                middle: '',
                prefix: '',
                last: '',
                suffix: '',
                first: ''
            },
            // created : 0,
            gender: '',
            brand: '',
            site: '',
            employee: {
                employeeId: undefined
            },
            profileId: 0,
            dateOfBirth: {
                month: undefined,
                day: undefined,
                year: undefined
            },
            defaultPaymentId: '',
            lastModified: 0,
            emailAddress: '',
            student: {
                // college: false,
                graduation: 0
            },
            defaultShippingAddressId: '',
            id: ''
        };

        this.preferences = {
            web: {
                interstitialDeclined: true
            },
            lastModified: 0,
            mobileApp: {
                coachmarkMyuoSeen: true,
                loyaltyAppDownloaded: true,
                loyaltySetupWizard: true,
                loyaltyInterstitialCancel: true
            },
            global: {
                language: "en",
                country: "US",
                profilePhoto: "",
                favoriteStores: [],
                currency: "USD",
                coverPhoto: ""
            },
            socialMedia: {
                twitter: {
                    userName: "string",
                    oAuthTokenSecret: "string",
                    connected: false,
                    oAuthToken: "string"
                },
                facebook: {
                    userName: "string",
                    oAuthTokenSecret: "string",
                    connected: false,
                    oAuthToken: "string"
                },
                instagram: {
                    userName: "string",
                    // oAuthTokenSecret: "string",
                    connected: false,
                    userId: "string",
                    oAuthToken: "string"
                }
            },
            profileId: "string"
        };

        this.subscriptions = {
            created: 0,
            lastModified: 0,
            loyalty: {
                loyaltyId: "",
                channelId: "WEB",
                loyaltyDate: 0,
                channel: "WEB"
            },
            id: "string",
            pushNotifications: {
                token: "string",
                subscriptionCategories: [
                    "string"
                ],
                tokenType: "string",
                pushAllowed: true
            },
            profileId: "string",
            // email: {
            //   email: "string",
            //   subscriptions: [
            //     {}
            //   ]
            // }
            email: {
                optedIn: false,
                categories: [{
                    items: {
                        date: "string",
                        aid: "string",
                        sub: "string",
                        listName: "string"
                    }
                }]
            }
        };

        this.stores = [];
        // Relationships property is used for templates to reference data from other models, it is read only
        this.relationships = {
            stores: StoreModel,
            auth: AuthModel
        };
        // Initialized property is used to determine if a property has been set from service data,
        // and if it needs a post on update
        this.initialized = {
            profile: {},
            preferences: {},
            subscriptions: {},
            employees: {},
            password: {},
            registryInfo: {}
        };
        this.errors = {
            location: '',
            data: ''
        };
        this.tempDemographics = {
            profile: {
                dateOfBirth: {
                    month: undefined,
                    day: undefined,
                    year: undefined
                },
                student: {
                    college: false,
                    graduation: 0
                }
            }
        };
        this.tempProfile = {
            profile: {},
            demographics: {}
        };

        this.password = {
            oldPassword: '',
            password: '',
            confirmPassword: ''
        };

        this.editableDemographics = '';
        this.editableStoreDelete = '';
        this.editableStoreSearch = '';
        this.editableProfile = '';
        this.editablePassword = '';

        this.registryInfo = {};

        this.getState = configureStore().getState;
        this.store = configureStore();
    }

    updatePassword(model, selector, modelProperty, token, serviceMethod, viewModel) {
        if (viewModel.viewStates.personalInfoUpdatePW) {
            const $formInputs = jQuery(selector)
                .closest('form')
                .find('.js-account-pass-input');
            return this.updateAllValues(model, modelProperty, token, serviceMethod, viewModel, $formInputs, ProfileController);
        } else {
            return new Promise(function(resolve, reject) {
                resolve(true);
            });
        }
    }

    /**
     * Method called from profileViewModel to update Email Subscriptions. Creates a new subscriptions object based on current
     * model values. Send object to accountModel.updateData
     * @param {Object} model
     * @param {string} selector
     * @param {string} modelProperty
     * @param {string} token
     * @param {string} the service method to call
     */
    updateSubscriptionsEmail(model, selector, modelProperty, token, serviceMethod) {
            const subscriptionValue = this.subscriptions.email.optedIn;
            const subscriptionAction = (typeof subscriptionValue != undefined && subscriptionValue) ? "Unsub" : "Sub";
            const subscriptionsEmail = {
                currentEmailId: this.profile.emailAddress,
                action: subscriptionAction,
                gender: this.profile.gender,
                listName: "",
                source: "footer"
            };

            super.setInitialized('subscriptions', true, false);

            return Service.updateSubscriptionsEmail(subscriptionsEmail, token);

        }
        /**
         * Method called from profileViewModel to update preferences. Creates a new preferences object based on current
         * model values. Send object to accountModel.updateData
         * @param {Object} model
         * @param {string} selector
         * @param {string} modelProperty
         * @param {string} token
         * @param {string} serviceMethod
         * @param {string} viewModel
         * @returns {object} Promise to resolve
         */
    updatePreferencesSocialMedia(model, selector, modelProperty, token, serviceMethod, viewModel) {
            const socialNetwork = selector.parent().attr('id');

            // if (socialNetwork == 'instagram' && the social auth worked) {
            if (socialNetwork === 'instagram') {
                const instagramProps = {
                    socialMedia: {
                        instagram: {
                            userName: "ali",
                            connected: selector.hasClass('connect'),
                            userId: "string",
                            // oAuthTokenSecret: "string",
                            oAuthToken: "string"
                        },
                        twitter: model.preferences.socialMedia.twitter
                    }
                };
                // console.log(instagramProps.socialMedia.instagram.connected);
                super.setData(instagramProps, modelProperty);
            }

            // if (socialNetwork == 'twitter' && the social auth worked) {
            if (socialNetwork === 'twitter') {
                const twitterProps = {
                    socialMedia: {
                        twitter: {
                            userName: "string",
                            connected: selector.hasClass('connect'),
                            oAuthTokenSecret: "string",
                            oAuthToken: "string"
                        },
                        instagram: model.preferences.socialMedia.instagram
                    }
                };
                // console.log(twitterProps.socialMedia.twitter.connected);
                super.setData(twitterProps, modelProperty);
            }

            return super.updateData(model, token, serviceMethod, modelProperty, viewModel, ProfileController, selector);
        }
        /**
         * Call the service method for creating a loyalty subscription
         * @param {Object} model - The profile model
         * @param {string} selector - Element used to trigger createUrbanOn event
         * @param {string} modelProperty - The subscriptions property
         * @param {string} token - Auth model
         * @param {string} serviceMethod - the createLoyaltySubscription service method
         */
    createUrbanOn(model, selector, modelProperty, token, serviceMethod, viewModel) {
            console.log('createUrbanOn Fired!');
            return super.updateData(model, token, serviceMethod, modelProperty, viewModel, ProfileController, selector);

        }
        /**
         * DEPRECATED
         */
        // saveTempName(model, selector, modelProperty, token, serviceMethod,viewModel,makeServiceCall,result){
        //     let _this = this;
        //     let $demographicFormInputs = jQuery('#basics-form').find('.js-account-basics-form-item');
        //     $demographicFormInputs.each(function(index){
        //         let $this = jQuery(this);
        //         let parts = $this.attr('name');
        //         let value = $this.val();

    //         super.recursiveData(parts,value,model[modelProperty],model);
    //     });

    //     return Promise.resolve(super.setData(this.tempName,'editableName',true));
    // }
    /**
     * DEPRECATED
     */
    // showEditableProfile(model, selector, modelProperty, token, serviceMethod,viewModel,makeServiceCall,result){
    //     $.extend(true, this.tempProfile.profile, this.profile);
    //     return Promise.resolve(super.setData(this.tempProfile,'editableProfile',true))
    // }
    /**
     * DEPRECATED
     */
    // saveTempDemographics(model, selector, modelProperty, token, serviceMethod,viewModel,makeServiceCall,result){
    //     console.log('saveTempDemographics');
    //     let _this = this;
    //     let $demographicFormInputs = jQuery('.js-account-profile-demographics-form').find('.js-account-demographics-form-item');
    //     $demographicFormInputs.each(function(index){
    //         let $this = jQuery(this);
    //         let parts = $this.attr('name');
    //         let value = $this.val();

    //         if(parts === 'profile.student.college') {
    //             if ($this[0].checked) {
    //                 value = JSON.parse($this.val());
    //             }
    //         }

    //         super.recursiveData(parts,value,model[modelProperty],model);
    //     });

    //     return Promise.resolve(super.setData(this.tempDemographics,'editableDemographics',true));
    // }
    /**
     * Call the service method for creating a loyalty subscription
     * @param {Object} model - The profileModel
     * @param {string} selector - Element used to trigger saveEmployee event
     * @param {string} modelProperty - The profile property
     * @param {string} token - Auth model
     * @param {string} serviceMethod - The updateProfile service method
     * @param {object} viewModel - The profileViewModel
     */
    saveEmployee(model, selector, modelProperty, token, serviceMethod, viewModel) {
        const employeeIdNumber = jQuery('.js-account-employee-id-number').val();
        const employeeContinent = jQuery('.js-account-employee-continent:checked').val();
        const employeeTerms = jQuery('.js-account-employee-terms:checked').is(':checked');
        const employeeProps = {
            employeeId: employeeIdNumber,
            continent: employeeContinent,
            terms: employeeTerms
        };

        super.setData({
            employee: employeeProps
        }, modelProperty);

        return this.updateData(model, token, serviceMethod, modelProperty, viewModel, ProfileController, selector);
    }

    checkEmployeeId(model, selector, modelProperty, token, serviceMethod, viewModel) {
        if (!model.errors.data === '') {
            model.profile.employee.employeeId = undefined;
        }
    }

    setDefaultAddress(model, selector, modelProperty, token, serviceMethod, viewModel) {
        const currentAddressId = jQuery(selector).attr('data-address-id');
        super.setData({
            defaultShippingAddressId: currentAddressId
        }, modelProperty);
        return this.updateData(model, token, serviceMethod, modelProperty, viewModel, ProfileController, selector);
    }

    setDefaultAddressFromNewForm(altModel, selector, modelProperty, token, serviceMethod, viewModel, model, makeServiceCall, results) {
        if (typeof results[1] === 'undefined') {
            return Promise.resolve(true);
        }

        if (viewModel.viewStates.newAddressInPaymentForm || viewModel.viewStates.newAddress || viewModel.viewStates.editAddress) {
            const defaultAddrIsChecked = jQuery('.js-account-set-default-address').is(':checked');
            const currentAddressId = results[1].data.id;
            if (defaultAddrIsChecked) {
                super.setData({
                    defaultShippingAddressId: currentAddressId
                }, modelProperty);
                return this.updateData(altModel, token, serviceMethod, modelProperty, viewModel, ProfileController, selector);
            } else {
                return Promise.resolve(true);
            }
        } else {
            return Promise.resolve(true);
        }
    }

    setDefaultPayment(model, selector, modelProperty, token, serviceMethod, viewModel) {
        console.log('set default payment');
        const currentPaymentId = jQuery(selector).attr('data-payment-id');
        super.setData({
            defaultPaymentId: currentPaymentId
        }, modelProperty);
        return this.updateData(model, token, serviceMethod, modelProperty, viewModel, ProfileController, selector);
    }
    setDefaultPaymentFromNewForm(altModel, selector, modelProperty, token, serviceMethod, viewModel, model, makeServiceCall, results) {
        if (typeof results[3] === 'undefined') {
            return Promise.resolve(true);
        }

        const defaultPaymentIsChecked = jQuery('.js-account-set-default-payment').is(':checked');
        const currentPaymentId = results[3].data.id;

        if (defaultPaymentIsChecked) {
            super.setData({
                defaultPaymentId: currentPaymentId
            }, modelProperty);
            return this.updateData(altModel, token, serviceMethod, modelProperty, viewModel, ProfileController, selector);
        } else {
            return Promise.resolve(true);
        }
    }

    setDefaultAddressFromEditForm(model, selector, modelProperty, token, serviceMethod, viewModel) {
        const defaultAddrIsChecked = jQuery('.js-account-set-default-address').is(':checked');
        const currentAddressId = jQuery(selector).attr('data-address-id');
        const currentDefaultAddressId = model.profile.defaultShippingAddressId;

        if (defaultAddrIsChecked) {
            super.setData({
                defaultShippingAddressId: currentAddressId
            }, modelProperty);
        } else {
            // is the current address the default? if so, it was unchecked, unset it
            if (currentAddressId === currentDefaultAddressId) {
                super.setData({
                    defaultShippingAddressId: ''
                }, modelProperty);
            } else {
                super.setData({
                    defaultShippingAddressId: model.profile.defaultShippingAddressId
                }, modelProperty);
            }
        }

        return this.updateData(this, token, serviceMethod, modelProperty, viewModel, ProfileController, selector);
    }

    setDefaultFromPaymentsInEditForm(data, selector, token, viewModel) {
        const defaultAddrIsChecked = jQuery('.js-account-set-default-address').is(':checked');
        let addressId;
        if (typeof data.data !== 'undefined') {
            addressId = data.data.id;
        } else {
            addressId = data.slice(-1)[0].data.id;
        }
        if (defaultAddrIsChecked) {
            super.setData({
                defaultShippingAddressId: addressId
            }, 'profile');
            return this.updateData(this, token, 'updateProfile', 'profile', viewModel, ProfileController, selector);
        }
        return Promise.resolve(true);
    }

    setDefaultPaymentFromEditForm(model, selector, modelProperty, token, serviceMethod, viewModel) {
        const defaultPaymentIsChecked = jQuery('.js-account-set-default-payment').is(':checked');
        const currentPaymentId = jQuery(selector).attr('data-payment-id');
        const currentDefaultPaymentId = model.profile.defaultPaymentId;

        if (defaultPaymentIsChecked) {
            super.setData({
                defaultPaymentId: currentPaymentId
            }, modelProperty);
        } else {
            if (currentPaymentId === currentDefaultPaymentId) {
                super.setData({
                    defaultPaymentId: ""
                }, modelProperty);
            } else {
                super.setData({
                    defaultPaymentId: currentDefaultPaymentId
                }, modelProperty);
            }
        }

        return this.updateData(this, token, serviceMethod, modelProperty, viewModel, ProfileController, selector);

    }

    /**
     * Updates employeeId to include leading zeros as needed
     */
    updateEmployeeId() {
        const employeeId = _.get(this.profile, 'employee.employeeId');

        if (employeeId) {
            const employeeIdLength = employeeId.length;
            const formattedEmployeeId = formatEmployeeId(employeeId, employeeIdLength);
            this.profile.employee.employeeId = formattedEmployeeId;
        }
    }

    /**
     * Use ioBarcode library to create a barcode for employee ids, so this can be scanned in stores
     */
    generateBarCode() {
        const employeeId = _.get(this.profile, 'employee.employeeId');
        if (employeeId) {
            const canvas = CODE39(employeeId, {
                width: 1,
                height: 25
            });
            this.employeeBarcode = canvas.toDataURL('image/png');
        }
        return Promise.resolve(this);
    }

    /**
     * Delete the generated barcode if the employee id entered is not valid
     * @returns {undefined}
     */
    deleteBarcode() {
        this.employeeBarcode = '';
        this.profile.employee.employeeId = undefined;
    }

    showEditableStoreDelete(model, selector, modelProperty, token, serviceMethod) {
        const selectedStoreId = jQuery(selector).attr('data-store-id');
        return super.setData(selectedStoreId, modelProperty, true);
    }

    showEditableStoreSearch(model, selector, modelProperty, token, serviceMethod) {
        const searchedStoreText = jQuery('.js-account-search-profile-store-input').val();
        return super.setData(searchedStoreText, modelProperty, true);
    }

    saveTemps(model, selector, modelProperty) {
        const editable = modelProperty.replace('temp', 'editable');
        const form = jQuery(selector).parents('form');
        const $formInputs = modelProperty === 'password' ? form.find('.js-account-pass-input') : form.find('.js-account-basics-form-item');

        $formInputs.each(function(index) {
            const $this = jQuery(this);
            const parts = $this.attr('name');
            const value = $this.val();
            model.recursiveData(parts, value, model[modelProperty], model);
        });
        return Promise.resolve(super.setData(model[modelProperty], editable, true));
    }

    resetTemps(model, selector, modelProperty, token, serviceMethod, viewModel) {
        this.editableProfile = '';
        this.editablePassword = '';
        viewModel.updateViewState('profileShowErrors', false);
        return Promise.resolve(true);
    }

    authWithNewPassword() {
        const params = {
            newPassword: this.password.password,
            userName: this.profile.emailAddress
        };

        return Promise.resolve(Service.authWithNewPassword(params));
    }

    sendTokenToLoginModal(model, selector, modelProperty, token, serviceMethod, viewModel, makeServiceCall, results) {
        return Promise.resolve(Service.triggerLoginSuccess(results));
    }

    /**
     * Sending email to /credentials if edited email is different from previous email
     **/
    updateEmailForCheetah(model, selector, modelProperty, token, serviceMethod, viewModel) {
        const oldEmail = this.profile.emailAddress;
        const updatedEmail = jQuery(selector)
            .closest('form')
            .find('input[name="profile.emailAddress"]')
            .val();

        if (oldEmail != updatedEmail) {
            return Service[serviceMethod](updatedEmail, token, model, viewModel, ProfileController, selector);
        }
    }

    /**
     * Update first and last name in basics section of account settings
     **/
    updateFirstLastName(model, selector, modelProperty, token, serviceMethod, viewModel) {
        const firstName = jQuery(selector)
            .closest('form')
            .find('input[name="profile.name.first"]');
        const lastName = jQuery(selector)
            .closest('form')
            .find('input[name="profile.name.last"]');
        const emailAddress = jQuery(selector)
            .closest('form')
            .find('input[name="profile.emailAddress"]');
        const formInputs = [];

        formInputs.push(firstName, lastName, emailAddress);

        if (this.store.getState().core.constants.accountOptions.showUsername) {
            const userName = jQuery(selector)
                .closest('form')
                .find('input[name="profile.loyaltyUserName"]');

            formInputs.push(userName)
        }

        return super.updateAllValues(model, modelProperty, token, serviceMethod, viewModel, jQuery(formInputs));
    }

    /**
     * If 'no' for the in school input, update the model so that the graduation year drop down doesn't show
     * @returns {undefined}
     **/
    updateSchoolStatus() {
        this.profile.student.college = false;
    }

    /**
     * Get date of birth in ISO-8601 format
     */
    getISODateOfBirth() {
        const profile = this.profile;

        if (profile && profile.dateOfBirth) {
            const dob = profile.dateOfBirth;
            if (dob.year && dob.month && dob.day) {
                const dobDateObj = new Date(dob.year, dob.month - 1, dob.day);
                return dobDateObj.toISOString();
            }
        }

        return undefined;
    }

}

const Profile = new ProfileModel(StoreModel);

export default Profile;
